import { atom } from "recoil";

export interface UserSimpleType {
  accessToken?: string;
  nickname?: string;
  email?: string;
  userId?: number;
  trackId?: string;
  authenticateType?: string;
  isSubscribing?: boolean;
  hasAlreadyUsed?: boolean;
}

export const userSimpleAtom = atom<UserSimpleType | undefined>({
  key: "userSimple",
  default: undefined,
  // accessToken은 메모리에만 저장 (XSS 공격 방지)
  // refreshToken은 httpOnly 쿠키로 서버에서 관리
});
